import React from "react";
import ImageUtils from "./ImageUtils";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ReusableCertifiedIcon = ({ certifieddata }) => {
  const imageUtil = new ImageUtils();

  return (
    <>
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={
          <Tooltip id="button-tooltip">
            <span> Certified by : {certifieddata?.certifiedBy}</span>
          </Tooltip>
        }
      >
        <span className="px-2">
          <img
            alt="#"
            src={imageUtil.getImage("certified")}
            className="certified-logo-size"
          />
        </span>
      </OverlayTrigger>
    </>
  );
};

export default ReusableCertifiedIcon;
